import React from 'react';

export const SEVERITY_COLORS = {
  critical: 'bg-red-100 text-red-800 border-red-300 dark:bg-red-900/30 dark:text-red-300 dark:border-red-800',
  warning:  'bg-amber-100 text-amber-800 border-amber-300 dark:bg-amber-900/30 dark:text-amber-300 dark:border-amber-800',
  info:     'bg-sky-100 text-sky-800 border-sky-300 dark:bg-sky-900/30 dark:text-sky-300 dark:border-sky-800',
};

export const KIND_LABEL = {
  stale: 'Stale',
  duplicate: 'Duplicate',
  orphan: 'Orphaned',
  noisy_alert: 'Noisy alert',
  unused_ai_model: 'Unused AI model',
};

export function Kpi({ icon: Icon, label, value, sub, tone = 'default' }) {
  const toneClasses = {
    default: 'border-slate-200 dark:border-slate-700',
    good: 'border-emerald-300 dark:border-emerald-800',
    warn: 'border-amber-300 dark:border-amber-800',
    bad: 'border-red-300 dark:border-red-800',
  };
  return (
    <div className={`rounded-lg border ${toneClasses[tone]} bg-white dark:bg-slate-900/50 p-4`}>
      <div className="flex items-center gap-2 text-slate-500 text-xs uppercase tracking-wide">
        {Icon && <Icon size={14} />}
        {label}
      </div>
      <div className="mt-2 text-3xl font-semibold text-slate-900 dark:text-slate-50 tabular-nums">{value}</div>
      {sub && <div className="mt-1 text-xs text-slate-500">{sub}</div>}
    </div>
  );
}

export function Section({ title, children, right }) {
  return (
    <div className="mb-6">
      <div className="flex items-center justify-between mb-3">
        <h3 className="text-sm font-semibold uppercase tracking-wider text-slate-600 dark:text-slate-400">{title}</h3>
        {right}
      </div>
      {children}
    </div>
  );
}
